import {needAuth} from "../instance/Instance";
import {apiRequest} from "../../components/Utils/SimmsUtils";

async function getCustomCodeList() {
    try{
        return  await needAuth.get('/customcodes');
    }catch (error){
        return error;
    }
}
async function getGroupSelectByFieldEntity(fieldId) {
    try{
        return  await needAuth.get(`/customcodes/select/${fieldId}`);
    }catch (error){
        return error;
    }
}
async function getCustomStringList() {
    try{
        return  await needAuth.get('/customcodes/string');
    }catch (error){
        return error;
    }
}
async function getGroupSelectList() {
    try{
        return  await needAuth.get('/customcodes/select');
    }catch (error){
        return error;
    }
}
async function getGroupSelectListField() {
    try{
        return  await needAuth.get('/customcodes/select-field');
    }catch (error){
        return error;
    }
}
async function createCustomCode(customCode) {
    try{
        console.log(">>> api : 사용자코드 등록")
        return await needAuth.post('/customcodes', customCode);
    }catch (error){
        return error;
    }
}

async function createCustomCodeAtDrawer(data, success, duplicated){
    return apiRequest(
        () => needAuth.post(`/customcodes`, data),
        success,
        duplicated,
    );
}

async function createCustomString(customString) {
    try{
        return await needAuth.post('/customcodes/string', customString);
    }catch (error){
        return error;
    }
}
async function createGroupSelect(groupSelect) {
    try{
        return await needAuth.post('/customcodes/select', groupSelect);
    }catch (error){
        return error;
    }
}



async function deleteCustomCode(id) {
    try{
        return  await needAuth.delete('/customcodes/'+id);
    }catch (error){
        return error;
    }
}
async function deleteCustomString(id) {
    try{
        return  await needAuth.delete('/customcodes/string/'+id);
    }catch (error){
        return error;
    }
}
async function deleteGroupSelect(id) {
    try{
        return  await needAuth.delete('/customcodes/select/'+id);
    }catch (error){
        return error;
    }
}

async function updateCustomCode(customCode) {
    try{
        console.log(">>> api : 사용자코드 수정")
        return  await needAuth.put('/customcodes', customCode);
    }catch (error){
        return error;
    }
}
async function updateCustomString(customString) {
    try{
        console.log(">>> api : 사용자코드 수정")
        return  await needAuth.put('/customcodes/string', customString);
    }catch (error){
        return error;
    }
}
async function updateGroupSelect(groupSelect) {
    try{
        console.log(">>> api : 사용자코드 수정")
        return  await needAuth.put('/customcodes/select', groupSelect);
    }catch (error){
        return error;
    }
}

export {
    getCustomCodeList,
    getCustomStringList,
    getGroupSelectList,
    createCustomCode,
    createCustomString,
    createGroupSelect,
    getGroupSelectByFieldEntity,
    deleteCustomString,
    deleteCustomCode,
    deleteGroupSelect,
    updateCustomCode,
    updateCustomString,
    getGroupSelectListField,
    updateGroupSelect,
    createCustomCodeAtDrawer
};